// extracted by mini-css-extract-plugin
module.exports = {"enclose":"style_enclose__33Gk5","privacyBox":"style_privacyBox__18B2P","content":"style_content__2QPId"};